import { render, staticRenderFns } from "./BasePicture.vue?vue&type=template&id=4a216ace"
import script from "./BasePicture.vue?vue&type=script&lang=ts"
export * from "./BasePicture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports